import routePaths from '@/seo/routes.json';

const namespace = 'skinengine';
const skinengineBasePath = routePaths.skinengine.base;
const toChildPath = (absolutePath) => absolutePath.replace(`${skinengineBasePath}/`, '');
const ProjectLayout = () => import(/* webpackChunkName: "skinengine-layout" */ './ProjectLayout.vue');
const Home = () => import(/* webpackChunkName: "skinengine-home" */ './views/Home.vue');
const Download = () => import(/* webpackChunkName: "skinengine-download" */ './views/Download.vue');
const Packs = () => import(/* webpackChunkName: "skinengine-packs" */ './views/Packs.vue');
const Submit = () => import(/* webpackChunkName: "skinengine-submit" */ './views/Submit.vue');
const Editor = () => import(/* webpackChunkName: "skinengine-editor" */ './views/Editor.vue');
const NotFound = () => import(/* webpackChunkName: "not-found" */ '../../views/NotFound.vue');

export default function getSkinEngineRoutes(config) {
  const route = {
    path: skinengineBasePath,
    component: ProjectLayout,
    meta: {
      namespace,
    },
    children: [
      {
        path: '',
        name: 'skinengine',
        component: Home,
        meta: {
          namespace,
          searchScope: namespace,
        },
      },
      {
        path: toChildPath(routePaths.skinengine.editor),
        name: 'editor-home',
        component: Editor,
        meta: {
          namespace,
          searchScope: null,
        },
      },
      {
        path: toChildPath(routePaths.skinengine.editorDemo),
        redirect: routePaths.skinengine.editor,
        meta: {
          namespace,
          searchScope: null,
        },
      },
      {
        path: 'editor/:id',
        name: 'editor',
        component: Editor,
        meta: {
          namespace,
          searchScope: null,
        },
      },
    ],
  };

  if (!config.selfHosted) {
    route.children.push(
      {
        path: toChildPath(routePaths.skinengine.download),
        name: 'download',
        component: Download,
        meta: {
          namespace,
          searchScope: null,
        },
      },
      {
        path: toChildPath(routePaths.skinengine.packs),
        name: 'packs',
        component: Packs,
        meta: {
          namespace,
          searchScope: null,
        },
      },
      {
        path: toChildPath(routePaths.skinengine.packsSubmit),
        name: 'packs-submit',
        component: Submit,
        meta: {
          namespace,
          searchScope: null,
        },
      },
    );

    route.children.push({
      path: 'wiki',
      component: () => import(/* webpackChunkName: "wiki" */ './views/Wiki.vue'),
      redirect: routePaths.skinengine.wikiHome,
      meta: {
        namespace,
        searchScope: namespace,
      },
      children: [
        {
          path: ':page',
          name: 'wiki-article',
          component: () => import(/* webpackChunkName: "wiki" */ '../../components/Wiki/Article'),
          meta: {
            namespace,
            searchScope: namespace,
          },
        },
      ],
    });
  }

  route.children.push({
    path: '*',
    name: 'skinengine-not-found',
    component: NotFound,
    meta: {
      namespace,
      searchScope: null,
    },
  });

  return route;
}
